(function (window) {

  /**
   * @class
   */
  const ViewBase = Class(
    /**
     * @lends {ViewBase#}
     */
    {
      /** @type {SectionDid} */
      controller: null,
      /** @type {Object} */
      par: null,
      /**
       * @param {SectionDid} controller
       * @param {Object} par
       * @private
       */
      __construct (controller, par) {
        this.controller = controller;
        this.par = par || {};
        this.draw();
        const toggle = document.querySelector('#header-wrapper');
        if (toggle) {
          mkE({
            tag: 'div',
            id: 'header-wrapper',
            els: [
              {
                tag: 'header',
                id: 'header',
                els: [
                  {
                    tag: 'div',
                    className: 'header-content',
                    els: [
                      {
                        tag: 'div',
                        className: 'header-top',
                        els: [
                          {
                            tag: 'div',
                            className: 'menu-logo',
                            els: [
                              { tag: 'span', id: 'logo' },
                              {
                                tag: 'span',
                                id: 'logo_dg',
                                els: [
                                  {
                                    tag: 'img',
                                    src: '/assets/images/logo-dg.svg',
                                    width: '89',
                                    height: '14',
                                    alt: 'Draugiem Group'
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }).replace(toggle);
        }

      },
      /** @abstract */
      draw () {
      }
    },
    mkE.Base
  );

  const ViewIntro = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-5',
              innerHTML: 'QR kodu izaicinājums <b>"Labākais padoms drošībai internetā"</b> ir interesanta meklēšanas un domāšanas spēle.'
            },
            {
              tag: 'p',
              innerHTML: 'Tavs uzdevums ir atrast 20 QR kodus un atbildēt uz jautājumiem! <br><br>' +
                'Atbildi pareizi vismaz uz 10 jautājumiem un piedalies balvu izlozē!<br><br><br>' +
                '<strong>ATRODI UN NOSKENĒ QR KODU, LAI UZZINĀTU JAUTĀJUMU!</strong>'
            }
          ]
        });
        this.controller.rpc.send('intro', {}, this._onLoad);
      },
      _onLoad (re) {
        if (re.error) {
          switch (re.error) {
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            default:
              this.controller.navigateTo('error');
              return;
          }
        }
        this.controller.ready();
      }
    },
    ViewBase
  );

  const ViewClosed = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-5',
              innerHTML: 'QR kodu izaicinājums <b>"Labākais padoms drošībai internetā"</b> ir interesanta meklēšanas un domāšanas spēle.'
            },
            {
              tag: 'div',
              els: [
                {
                  tag:'p',
                  className: 'mb-2',
                  text: 'Spēle noslēgusies. Paldies, ka piedalījies!'
                },
                // {
                //   tag: 'p',
                //   els: [
                //     'Izlozes rezultātus varēsi redzēt 3. martā šeit: ',
                //     {
                //       tag: 'b',
                //       els: [
                //         {
                //           tag: 'a',
                //           href: 'https://drossinternets.lv',
                //           text: 'drossinternets.lv'
                //         }
                //       ]
                //     }
                //   ]
                // }
              ]
            }
          ]
        });
        this.controller.ready();
      }
    },
    ViewBase
  );

  const ViewError = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-5',
              text: this.par.errorTitle || `Sistēmas kļūda`
            },
            {
              tag: 'p',
              text: this.par.errorMessage || 'Mēģini vēlāk...'
            }
          ]
        });
        this.controller.ready();
      }
    },
    ViewBase
  );

  const ViewRegister = Class(
    {
      draw () {
        this.node = mkE({
          tag: 'div',
          className: 'container view',
          els: [
            {
              tag: 'h1',
              className: 'mb-5',
              innerHTML: 'QR kodu izaicinājums <b>"Labākais padoms drošībai internetā"</b> ir interesanta meklēšanas un domāšanas spēle.'
            },
            {
              tag: 'p',
              className: 'mb-5',
              innerHTML: 'Tavs uzdevums ir atrast 20 QR kodus un atbildēt uz jautājumiem! <br><br>' +
                'Atbildi pareizi vismaz uz 10 jautājumiem un piedalies balvu izlozē!'
            },
            {
              tag: 'a',
              className: 'button button-pink d-block',
              text: 'Sākt',
              onclick: this._onRegisterSubmit,
            }
          ]
        });
        this.controller.ready();
      },
      // _onClickContinue () {
      //   clearNode(this.node);
      //   this.node = mkE({
      //     tag: 'form',
      //     className: 'container flex-column view view__register',
      //     onsubmit: this._onRegisterSubmit,
      //     attr: {
      //       novalidate: '',
      //     },
      //     els: [
      //       {
      //         tag: 'h1',
      //         text: 'Piesakies Kvadrātkodu izaicinājumā!'
      //       },
      //       {
      //         tag: 'div',
      //         className: 'fieldset mb-4',
      //         els: [
      //           this._inputSchool = new T.Form.Input({
      //             caption: 'Skola, bibliotēka u.c.',
      //             border: true,
      //             attr: {
      //               maxlength: 255
      //             }
      //           }),
      //           { tag: 'br' },
      //           this._inputGrade = new T.Form.Input({
      //             caption: 'Klase',
      //             border: true,
      //             attr: {
      //               maxlength: 255
      //             }
      //           })
      //         ]
      //       },
      //       this._inputSubmit = mkE({
      //         tag: 'button',
      //         type: 'submit',
      //         className: 'button button-pink',
      //         text: 'Sākt izaicinājumu'
      //       })
      //     ]
      //   }).replace(this.node);
      //   this.controller.rpc.send('registration', {}, this._onLoadRegistration);
      // },
      // _onLoadRegistration (re) {
      //   if (re.error) {
      //     switch (re.error) {
      //       case 'closed':
      //         this.controller.navigateTo('closed');
      //         return;
      //       default:
      //         this.controller.navigateTo('error');
      //         return;
      //     }
      //   }
      // },
      _onRegisterSubmit (e) {
        // e.preventDefault();
        // const school = this._inputSchool.value();
        // const grade = this._inputGrade.value();
        this.controller.rpc.send(
          'register',
          {
            school: '',
            grade: '',
          },
          this._onRegister
        );
      },
      _onRegister: function (re) {
        if (re.error) {
          switch (re.error) {
            case 'already registered':
              // Continue
              break;
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            case 'invalid data':
            default:
              this.controller.navigateTo('error');
              return;
          }
        }
        this.controller.navigateTo('question');
      },
    },
    ViewBase
  );

  const ViewQuestion = Class(
    {
      _answer: 0,
      draw () {
        this.code = this.controller.code;
        this.node = mkE({
          tag: 'div',
          className: 'view view__question flex-column'
        });
        D.loadingOverlay(this.node, { delay: true });
        this.controller.rpc.send('question', { code: this.code }, this._onLoadQuestion);
      },
      _onLoadQuestion (re) {
        this.question = re;
        D.removeLoadingOverlay(this.node);
        if (re.error) {
          switch (re.error) {
            case 'auth':
              this.controller.navigateTo('register');
              return;
            case 'closed':
              this.controller.navigateTo('closed');
              return;
            case 'invalid code':
            case 'invalid data':
            default:
              this.controller.navigateTo('error', {
                errorTitle: 'Nederīgs kods',
                errorMessage: 'Kaut kas nav pareizi...',
              });
              return;
          }
        }
        this._draw();
        this.controller.ready();
      },
      _draw () {
        clearNode(this.node);
        const q = this.question;
        const c = Number(q.count) + (q.hasAnswered ? 0 : 1);
        mkE.appendTypeElement(this.node, [
          {
            tag: 'div',
            className: 'header',
            els: [
              {
                tag: 'div',
                className: 'container',
                els: [
                  {
                    tag: 'img',
                    src: '/assets/images/did/coder.svg',
                    width: 30
                  },
                  {
                    tag: 'div',
                    els: [
                      {
                        tag: 'h1',
                        text: 'Labākais padoms drošībai internetā'
                      },
                      {
                        tag: 'p',
                        text: `${c} no 20 jautājumiem`
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            tag: !q.hasAnswered ? 'form' : 'div',
            onsubmit: this._onSubmit,
            className: 'form container flex-column',
            els: [
              {
                tag: 'h2',
                className: 'mb-3 question ' + (q.hasAnswered ? 'expandable contracted' : ''),
                onclick: (e) => {
                  if (q.hasAnswered) {
                    toggleClassName(e.currentTarget, 'contracted');
                  }
                },
                els: [
                  { tag: 'div', text: q.question }
                ]
              },
              {
                tag: 'div',
                className: 'flex-column mb-2 answers',
                style: {
                  flexGrow: 0
                },
                els: (() => {
                  let els = [];
                  for (let i = 0; i < q.answers.length; i++) {
                    const answer = q.answers[i];
                    const className = [];
                    if (answer.selected) {
                      className.push(q.isCorrect ? 'correct' : 'wrong');
                    } else if (q.hasAnswered && q.correct === answer.id) {
                      className.push('correct');
                    }
                    els.push({
                      tag: 'label',
                      className: className.join(' '),
                      els: [
                        !q.hasAnswered ? {
                          tag: 'input',
                          type: 'radio',
                          value: answer.id,
                          name: 'answer',
                          onchange: this._onChange
                        } : '',
                        { tag: 'span', text: answer.text },
                      ]
                    });
                  }
                  if (q.hasAnswered) {
                    if (q.count === q.total) {
                      els.push({
                        tag: 'label',
                        className: 'result correct',
                        els: [
                          {
                            tag: 'span',
                            className: 'flex-column',
                            els: [
                              {
                                tag: 'strong',
                                text: `Tu esi atbildējis uz visiem 20 jautājumiem`
                              },
                              {
                                tag: 'div',
                                innerHTML:
                                  'Spēle noslēgusies. Paldies, ka piedalījies!' +
                                  (q.countCorrect > 10 ? '<br>Dodies uz Drossinternets.lv telti un izlozē balviņu.' : '')

                              }
                            ]
                          }
                        ]
                      });
                    } else {
                      els.push({
                        tag: 'label',
                        className: 'result ' + (q.isCorrect ? 'correct' : 'wrong'),
                        els: [
                          {
                            tag: 'span',
                            className: 'flex-column',
                            els: [
                              {
                                tag: 'strong',
                                text: (q.isCorrect ? 'Pareizi!' : 'Nepareizi!')
                              },
                              {
                                tag: 'div',
                                text: q.message
                              }
                            ]
                          }
                        ]
                      });
                    }

                  }
                  return els;
                })()
              },
              !q.hasAnswered ? this._inputSubmit = mkE({
                tag: 'button',
                type: 'submit',
                className: 'button button-pink',
                text: 'IESNIEGT',
                disabled: true,
              }) : {
                tag: 'div',
                className: 'info',
                els: [
                  {
                    tag: 'div',
                    els: [
                      {
                        tag: 'div',
                        className: 'container',
                        els: [
                          {
                            tag: 'img',
                            src: '/assets/images/did/' + (q.countCorrect < 10 ? 'info.svg' : 'check.svg'),
                            width: 24
                          },
                          {
                            tag: 'div',
                            text: (() => {
                              if (q.countCorrect >= 10) {
                                return `Kopā esi pareizi atbildējis uz ${q.countCorrect} no 20 jautājumiem un piedalies izlozē. `;
                              } else if (q.count - q.countCorrect > 10) {
                                return 'Lai piedalītos izlozē par balvām, nepieciešams pareizi atbildēt uz 10 jautājumiem.';
                              } else if (10 - q.countCorrect > 1) {
                                return `Lai piedalītos izlozē par balvām, nepieciešams pareizi atbildēt uz vēl  ${10 - q.countCorrect} jautājumiem.`;
                              } else {
                                return 'Lai piedalītos izlozē par balvām, nepieciešams pareizi atbildēt vēl tikai uz 1 jautājumu.';
                              }
                            })()
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
            ]
          }
        ]);
      },
      _onChange (e) {
        this._answer = Number(e.currentTarget.value);
        this._inputSubmit.disabled = !(this._answer > 0);
      },
      _onSubmit (e) {
        if (this._inputSubmit.disabled) {
          return;
        }
        this._inputSubmit.disabled = true;
        e.preventDefault();
        this.controller.rpc.send(
          'answer',
          {
            code: this.code,
            answer: this._answer
          },
          this._onLoadQuestion
        );
      }
    },
    ViewBase
  );

  const SectionDid = Class(
    /**
     * @lends {SectionDid#}
     */
    {
      route () {
        this.code = this.url.shift();
      },
      __construct () {
        this.node = mkE({
          tag: 'div',
          id: 'SectionDid',
          className: 'flex-column',
          els: [
            {
              tag: 'div',
              className: 'container logo'
            },
            this.content = mkE({
              tag: 'div',
              className: 'content flex-column'
            })
          ]
        });
      },
      navigateTo (path, par) {
        clearNode(this.content);
        let view;
        switch (path) {
          case 'register':
            view = new ViewRegister(this, par);
            break;
          case 'question':
            view = new ViewQuestion(this, par);
            break;
          case 'closed':
            view = new ViewClosed(this, par);
            break;
          case 'error':
            view = new ViewError(this, par);
            break;
          default:
            view = new ViewIntro(this, par);
            break;
        }
        view.append(this.content);
      },
      draw () {
        this.layout.hideFooter = true;
        this.rpc = new RPC('/api/qrg/did_rpc.php');
        this.node.append(this.layout.ct());
        if (this.code) {
          this.navigateTo('question');
        } else {
          this.navigateTo('');
        }
      },
      onLeave () {
        this.layout.hideFooter = false;
      }
    },
    Section
  );

  window.SectionDid = SectionDid;

})(window);